import React from 'react';
import {useGame} from "../contexts/GameContext";
import PrizeCard from "./prize-card";

const PRIZE_COLORS: Record<string, string> = {
    "Full House": "#4CAF50",
    "First 5": "#FF5C5C",
    "Corners": "#FFA500",
    "1st Line": "#1E90FF",
    "2nd Line": "#9C27B0",
    "3rd Line": "#3F51B5"
};

const PrizeTable: React.FC = () => {
    const {prizes, prizeWinners} = useGame();

    const getWinnerInfo = (prizeName: string) => {
        const match = prizeWinners.find(entry => entry.prize.name === prizeName);
        return match?.player || null;
    };


    const urlParams = new URLSearchParams(window.location.search);
    const playerId = urlParams.get('playerId');

    return (
        <div style={{display: "flex", flexDirection: "column", gap: "6px", alignItems: "center", marginTop: "50px"}}>
            {prizes.map((entry, index) => {
                const winner = getWinnerInfo(entry.name);
                const bgColor = PRIZE_COLORS[entry.name] || "#FF5C5C";
                return (
                    <PrizeCard
                        key={entry.name}
                        prizeName={entry.name}
                        points={entry.points}
                        playerName={winner?.playerId !== playerId ? winner?.playerName as string : "You"}
                        playerIcon={winner?.profile ?? ""}
                        coinIconUrl={"./coin.png"}
                        backgroundColor={bgColor}
                    />
                );
            })}
        </div>
    );
};

export default PrizeTable;
